import React, { useCallback, useState } from "react";

import SearchIcon from "@mui/icons-material/Search";
import { TextField } from "@mui/material";
import { debounce } from "lodash";

import { useEmailsContext } from "../context/Email-context";

interface Props {}

export const Search: React.FC<Props> = () => {
  const { searchValue, setSearchValue } = useEmailsContext();
  const [localValue, setLocalValue] = useState(searchValue);

  const debouncedSearch = useCallback(
    debounce((value: string) => {
      setSearchValue(value);
    }, 500),
    []
  );

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Escape" || e.key === "Enter") {
      e.preventDefault();
      e.stopPropagation();
      (e.target as HTMLInputElement).blur();
    }
    if (e.key === "Escape") {
      debouncedSearch("");
      setLocalValue("");
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setLocalValue(value);
    debouncedSearch(value);
  };

  return (
    <TextField
      value={localValue}
      onChange={handleChange}
      onKeyDown={handleKeyDown}
      sx={{
        "& .MuiOutlinedInput-root": {
          height: "32px",
          "& fieldset": {
            border: "1px solid #e2e2e1"
          },
          "&:hover fieldset": {
            border: "1px solid #e2e2e1"
          },
          "&.Mui-focused fieldset": {
            border: "1px solid #e2e2e1",
            boxShadow: "none"
          }
        }
      }}
      placeholder="Search ..."
      slotProps={{
        input: {
          startAdornment: <SearchIcon sx={{ marginRight: "10px" }} />
        }
      }}
    />
  );
};
